import React from 'react';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 bg-brand-red text-white py-2.5 px-4 shadow-md" data-id="element-271">
      <p className="max-w-4xl mx-auto text-sm sm:text-base font-semibold text-center" data-id="element-272">
        🔥 OFERTA DE LANZAMIENTO — Solo disponible para las primeras 100
        mujeres. Quedan pocos accesos al precio de $17.
      </p>
    </div>;
}